import { fetcher, queryString, useRecoilQuery } from '@shared/hooks/recoil-query';
import { LowerRole } from '@shared/types';

import {
  giftItemInfoDataAtomFamily,
  giftItemInfoListDataAtom,
  giftItemInfoListStatusAtom,
  giftItemInfoStatusAtomFamily,
} from './giftItemInfo.atom';

const giftItemInfoPopulate = {
  populate: [
    'image',
    'detailImages',
    'headerImages',
    'deliveredImageList',
    'giftItemBrand',
    { path: 'choiceUnits', populate: ['image', 'giftItemBrand'] },
  ],
};

export const giftItemInfoListUrl = (role: LowerRole) =>
  `${role}/gift-item-info?${queryString(giftItemInfoPopulate)}`;

export const useGiftItemInfoListHook = (role: LowerRole) => {
  useRecoilQuery(
    giftItemInfoListStatusAtom,
    giftItemInfoListDataAtom,
    giftItemInfoListUrl(role),
    fetcher,
  );
};

export const giftItemInfoUrl = (id: string, role: LowerRole) =>
  `${role}/gift-item-info/${id}?${queryString(giftItemInfoPopulate)}`;

export const useGiftItemInfoHook = (id: string, role: LowerRole) => {
  useRecoilQuery(
    giftItemInfoStatusAtomFamily(id),
    giftItemInfoDataAtomFamily(id),
    giftItemInfoUrl(id, role),
    fetcher,
  );
};
